import React, { useState } from "react";
import "./BookNowModal.scss";

const PAYMENT_URL = "https://rzp.io/rzp/SprrLb3";
const API_BASE = process.env.REACT_APP_API_BASE || "/api";
const BOOKING_STORAGE_KEY = "cashflow_booking_details";

const CATEGORY_OPTIONS = [
  { value: "", label: "Select Category" },
  { value: "Entrepreneur", label: "Entrepreneur" },
  { value: "Professional", label: "Professional" },
  { value: "Student", label: "Student" },
  { value: "Womenpreneur", label: "Womenpreneur" },
];

const BookNowModal = ({ isOpen, onClose, sourcePage = "other" }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    category: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
  };

  const validate = () => {
    if (!form.name?.trim()) {
      setError("Please enter your name.");
      return false;
    }
    if (!form.phone?.trim()) {
      setError("Please enter your phone number.");
      return false;
    }
    if (!form.email?.trim()) {
      setError("Please enter your email.");
      return false;
    }
    if (!form.category) {
      setError("Please select a category.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setSubmitting(true);
    setError("");

    const payload = {
      name: form.name.trim(),
      phone: form.phone.trim(),
      email: form.email.trim(),
      category: form.category,
      sourcePage,
      submittedAt: new Date().toISOString(),
    };

    try {
      // Store in localStorage for thank-you/payment page and backup
      localStorage.setItem(BOOKING_STORAGE_KEY, JSON.stringify(payload));

      // Optional: send to server if endpoint exists
      try {
        await fetch(`${API_BASE}/register/book`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } catch (apiErr) {
        // Continue to payment even if API fails; data is in localStorage
        console.warn("Booking API save failed, using localStorage only.", apiErr);
      }

      onClose();
      window.open(PAYMENT_URL, "_blank");
    } catch (err) {
      setError("Something went wrong. Please try again.");
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="book-now-modal-overlay" onClick={onClose}>
      <div className="book-now-modal" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="book-now-modal-close"
          aria-label="Close"
          onClick={onClose}
        >
          ×
        </button>
        <h2 className="book-now-modal-title">Book Now</h2>
        <form onSubmit={handleSubmit} className="book-now-form">
          <div className="book-now-field">
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Name"
              autoComplete="name"
            />
          </div>
          <div className="book-now-field">
            <input
              type="tel"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="Phone Number"
              autoComplete="tel"
            />
          </div>
          <div className="book-now-field">
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email"
              autoComplete="email"
            />
          </div>
          <div className="book-now-field">
            <select
              name="category"
              value={form.category}
              onChange={handleChange}
              className="book-now-select"
            >
              {CATEGORY_OPTIONS.map((opt) => (
                <option key={opt.value || "default"} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          {error && <p className="book-now-error">{error}</p>}
          <button
            type="submit"
            className="book-now-submit"
            disabled={submitting}
          >
            {submitting ? "Submitting…" : "Submit Detail"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BookNowModal;
export { PAYMENT_URL, BOOKING_STORAGE_KEY, CATEGORY_OPTIONS };
